import * as reducerUtils from "../utils/reducerUtils";
import { actionType } from "../actions/folgebrevActions";

const INITIAL_STATE = [];
const folgebrevReducer = (state = INITIAL_STATE, action) =>
  reducerUtils.CreateNewReducer(state, action, actionType);

export default folgebrevReducer;
